import { RouteObject } from 'react-router-dom'
import { lazy } from 'react'
import ModuleGuard from '@/core/guards/ModuleGuard.tsx'
import ErrorPage from '@/pages/errors/ErrorPage.tsx'

const MARKETPLACE_ROUTES: RouteObject[] = [
  {
    path: 'marketplace',
    element: <ModuleGuard />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: 'orders',
        lazy: async () => {
          const MarketplaceOrdersPage = lazy(
            () => import('@/pages/marketplace/MarketplaceOrdersPage.tsx')
          )
          return { element: <MarketplaceOrdersPage /> }
        }
      },
      {
        path: 'marketplaces',
        lazy: async () => {
          const MarketplacesPage = lazy(
            () => import('@/pages/marketplace/MarketplacesPage.tsx')
          )
          return { element: <MarketplacesPage /> }
        }
      },
      {
        path: 'products',
        lazy: async () => {
          const MarketplaceProductsPage = lazy(
            () => import('@/pages/marketplace/MarketplaceProductsPage.tsx')
          )
          return { element: <MarketplaceProductsPage /> }
        }
      },
      {
        path: 'discounts',
        lazy: async () => {
          const DiscountsPage = lazy(
            () => import('@/pages/marketplace/DiscountsPage.tsx')
          )
          return { element: <DiscountsPage /> }
        }
      },
      {
        path: 'inventory',
        lazy: async () => {
          const InventoryPage = lazy(
            () => import('@/pages/marketplace/InventoryPage.tsx')
          )
          return { element: <InventoryPage /> }
        }
      }
    ]
  }
]

export default MARKETPLACE_ROUTES
